import { render, staticRenderFns } from "./factors.vue?vue&type=template&id=a27991b6&scoped=true"
import script from "./factors.vue?vue&type=script&lang=js"
export * from "./factors.vue?vue&type=script&lang=js"
import style0 from "./factors.vue?vue&type=style&index=0&id=a27991b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27991b6",
  null
  
)

export default component.exports